export default __webpack_public_path__ + "static/media/curacao_egaming@2x.e31e9ef0.png";